import React from "react";
import { CustomLink } from "../../models";
import "./custom-link-container.component.css";

export interface CustomLinkContainerProps {
    link: CustomLink
}

export const CustomLinkContainer: React.FC<CustomLinkContainerProps> = ({ link }) => {
    return (
        <a
            href={link.link}
            target="_blank"
            rel="noopener noreferrer"
            className="custom-link-container"
            style={{ borderLeft: `6px solid ${link.color}` }}
        >
            {link.image && (
                <img
                    src={link.image}
                    alt={link.image}
                    className="custom-link-image"
                />
            )}
            <span className="custom-link-title">{link.title}</span>
        </a>
    );
};
